export const PORTAL_ID = '00000000-0000-0000-0000-000000000001';
export const PORTAL_AREA = { type: 'portal', id: PORTAL_ID, name: 'Portal' };
